"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const react_helmet_1 = __importDefault(require("react-helmet"));
const CatalogMobileSubLinks_1 = require("@Components/CatalogMobileSubLinks");
const Status_1 = __importDefault(require("@Components/Status"));
const work_statuses_1 = require("@Const/work-statuses");
const TabsWrapperComponent_1 = __importDefault(require("@Components/TabsWrapperComponent"));
const contexts_1 = require("@App/contexts");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const RegistrationHistoryTab_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalogRegistrationHistory/RegistrationHistoryTab"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RightsholderCatalogRegistrationHistory = () => {
    const { uiStore, registrationHistoryStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_registration_history');
    }, []);
    const tabs = Array.from(registrationHistoryStore.registrationHistoryTabs, ([key, value]) => ({
        tabName: key.valueOf(),
        tabComponent: react_1.default.createElement(RegistrationHistoryTab_1.default, { type: key, key: key.valueOf(), registrationHistoryTabStore: value }),
    }));
    const isMobile = uiStore.isMobile;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Registration History' }),
        react_1.default.createElement("div", { className: 'rightsholder-catalog-history-wrapper' },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(ContentHeader_1.default, { title: 'Registration History', descriptionElement: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", null, "Registration History is a record of new work submissions or updates to existing works. Updates or registrations will be saved here for two years from the date of submission."),
                        react_1.default.createElement("p", null, "Updated information on an existing work will only show in the corresponding fields. New work submissions will show all fields.")) },
                    react_1.default.createElement(Status_1.default, { tooltip: 'Our system has received your suggested submission.', withCount: false, status: work_statuses_1.WORK_STATUSES.SUBMITTED, big: true }),
                    react_1.default.createElement(Status_1.default, { tooltip: 'Your submission was approved by our system.', withCount: false, status: work_statuses_1.WORK_STATUSES.ACCEPTED, big: true }),
                    react_1.default.createElement(Status_1.default, { tooltip: 'Your submission was rejected by our system.', withCount: false, status: work_statuses_1.WORK_STATUSES.REJECTED, big: true }),
                    react_1.default.createElement(Status_1.default, { tooltip: 'Your pending submission was overwritten by a newer submission.', withCount: false, status: work_statuses_1.WORK_STATUSES.SUPERSEDED, big: true })),
                react_1.default.createElement("br", null),
                isMobile && react_1.default.createElement(CatalogMobileSubLinks_1.CatalogMobileSubLinks, null),
                react_1.default.createElement(TabsWrapperComponent_1.default, { tabs: tabs, defaultTab: tabs[0] })))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderCatalogRegistrationHistory);
